// extracted by mini-css-extract-plugin
export default {"wrapButtonFooter":"create-quotation_wrapButtonFooter__RdXS8"};